/**
 * Plot height for the Monthly Billable Allocation and Hiring & Attrition line charts
 * in the Headcount Metrics row. Matches the shorter Allocated Headcount Overview card.
 */
export const HEADCOUNT_METRICS_LINE_CHART_HEIGHT_PX = 290;

/** Title + card padding + legend (approx.) — skeletons and loading placeholders */
export const HEADCOUNT_METRICS_CARD_ESTIMATED_HEIGHT_PX =
  HEADCOUNT_METRICS_LINE_CHART_HEIGHT_PX + 130;

/** Royal blue: Active “allocated” segment and Allocated “client” segment (same hue). */
export const HEADCOUNT_ALLOCATION_PRIMARY_BLUE = '#0061FF';

/** Horizontal bar height in Headcount Allocation (pill) — aligned with line-chart card weight */
export const HEADCOUNT_ALLOCATION_BAR_HEIGHT_PX = 28;